import { render, staticRenderFns } from "./followRules.vue?vue&type=template&id=5e3d3398&scoped=true"
import script from "./followRules.vue?vue&type=script&lang=js"
export * from "./followRules.vue?vue&type=script&lang=js"
import style0 from "./followRules.vue?vue&type=style&index=0&id=5e3d3398&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3d3398",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e3d3398')) {
      api.createRecord('5e3d3398', component.options)
    } else {
      api.reload('5e3d3398', component.options)
    }
    module.hot.accept("./followRules.vue?vue&type=template&id=5e3d3398&scoped=true", function () {
      api.rerender('5e3d3398', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/setup/ruleSettings/components/followRules.vue"
export default component.exports